
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseButton extends Vue {
  @Prop({ default: "" }) text!: string;
  @Prop({ default: "" }) styleButton!: string;
  @Prop({ default: "" }) size!: string;
  @Prop({ default: false }) isDisebled!: boolean;
  @Prop({ default: false }) iconVisible!: boolean;
}
